import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SEOMeta from '../components/SEOMeta';
import { getRouteSEO } from '../constants/routeSEO';
import AppHeader from './AppHeader';
import Footer from './Footer';

interface PrivateLayoutProps {
  children?: React.ReactNode;
}

const PrivateLayout: React.FC<PrivateLayoutProps> = ({ children }) => {
  const location = useLocation();
  const routeMeta = getRouteSEO(location.pathname);
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-orange-900 to-slate-900">
      <SEOMeta
        {...(routeMeta && { title: routeMeta.title, description: routeMeta.description })}
      />
      <AppHeader />
      <main className="min-h-[calc(100vh-80px)] overscroll-none">
        {children || <Outlet />}
      </main>
      <Footer />
    </div>
  );
};

export default PrivateLayout;

